module.exports = function() {
  return new Worker(__webpack_public_path__ + "d69425a559ae50b81275.worker.js");
};